<p #textContainer class="text-message">
    <span *ngFor="let character of academySvc.textMessageArray">{{character}}</span>
</p>
<button class="text-message-button" (click)="closeTextMessage()">Next</button>
